const projectOne = {
  namespaced: true,
  state: {
    projectOne: [],
  },
  getters: {},
  mutations: {},
  actions: {},
};

export default projectOne;
